import React from 'react';
import { connect } from 'react-redux';

//Components

import SmartMenu from '../index';
import WpBadge from 'Wpds/components/badge/WpBadge';
import WpAvatar from 'Wpds/components/avatar/WpAvatar';
import WpButton from 'Wpds/components/button/WpButton';
import WpIcon from 'Wpds/components/icon/WpIcon';
import { SmartLinkLogo } from '../../components';
import { DataSourceSlugs } from 'Shared/constants/types';

//Selectors
import { getAsanaSignUpUrl } from 'Shared/selectors/smartLinks';

//Logos
import AsanaLogo from 'Shared/images/AsanaLogo.svg';

//Styles
import '../SmartMenu.scss';
import { useTranslation } from 'Shared/utils/hooks/use-translation';

//Helpers
import { trackClickedConnectApp } from 'Shared/tracking/tracking';

const AsanaTaskSmartMenu = ({ children, ...props }) => {
  const { tr } = useTranslation();
  const { hasAsanaIntegration, asanaSignUpUrl } = props;

  const renderSmartLinkDetail = smart_link_detail => {
    const { status, assignee, assignee_avatar, creator, creator_avatar } = smart_link_detail;
    const badgeColor = status === 'Complete' ? 'green' : 'gray';
    const assignee_initials = assignee
      ? assignee.includes(' ')
        ? assignee.substr(0, 1) + assignee.split(' ')[1].substr(0, 1)
        : assignee.substr(0, 1)
      : '';
    const assignee_display_avatar = assignee_avatar
      ? assignee_avatar
      : { initials: assignee_initials, color: '#34B5AD' };
    const creator_initials = creator
      ? creator.includes(' ')
        ? creator.substr(0, 1) + creator.split(' ')[1].substr(0, 1)
        : creator.substr(0, 1)
      : '';
    const creator_display_avatar = creator_avatar ? creator_avatar : { initials: creator_initials, color: '#F5C20D' };
    const className = 'SmartMenu__content__row';
    return (
      <>
        {creator && (
          <div className={className}>
            <div className={`${className}__label`}>{tr('perform.smart_links.asana.creator_label')}</div>
            <div className={`${className}__value`}>
              <WpAvatar size="sm" avatar={creator_display_avatar}></WpAvatar>{' '}
              <div className={`${className}__value__text`}>{creator}</div>
            </div>
          </div>
        )}
        <div className={className}>
          <div className={`${className}__label`}>{tr('perform.smart_links.asana.assignee_label')}</div>
          <div className={`${className}__value`}>
            {assignee && <WpAvatar size="sm" avatar={assignee_display_avatar}></WpAvatar>}
            {!assignee && (
              <span className={`${className}__empty-user-icon`}>
                <WpIcon name="user" size="md"></WpIcon>
              </span>
            )}{' '}
            <div className={`${className}__value__text`}>
              {assignee}
              {!assignee && tr('perform.smart_links.asana.unassigned')}
            </div>
          </div>
        </div>
        <div className={className}>
          {tr('perform.smart_links.asana.status_label')}{' '}
          <div className={`${className}__value`}>
            <WpBadge color={badgeColor} size="md">
              {status}
            </WpBadge>
          </div>
        </div>
        <p />
        <a href={smart_link_detail.url} target="blank" rel="noopener norefferer">
          {tr('perform.smart_links.asana.view_task')}
        </a>
      </>
    );
  };

  const renderSmartLinkBadge = smart_link_detail => {
    const { status } = smart_link_detail;
    if (!status) return null;
    const badgeColor = status === 'Complete' ? 'green' : 'gray';
    return (
      <div>
        <WpBadge color={badgeColor} size="md">
          {status}
        </WpBadge>
      </div>
    );
  };

  const handleConnectClick = () => {
    trackClickedConnectApp(DataSourceSlugs.asana);
    window.location.href = asanaSignUpUrl;
  };

  const renderEmbedingContent = () => {
    const className = 'SmartMenu__content__button';
    return (
      <>
        <div className={className}>{tr('perform.smart_links.asana.connect_prompt')}</div>
        <p />
        <div className={className}>
          <WpButton variant="tertiary" onClick={handleConnectClick} block>
            {tr('perform.smart_links.asana.connect_cta')}
          </WpButton>
        </div>
      </>
    );
  };

  const menuTitle = smart_link_detail => (
    <>
      <SmartLinkLogo src={AsanaLogo} />
      {smart_link_detail.name}
    </>
  );

  return (
    <SmartMenu
      hasDocumentIntegration={hasAsanaIntegration}
      renderEmbedingContent={renderEmbedingContent}
      renderSmartLinkDetail={renderSmartLinkDetail}
      renderSmartLinkBadge={renderSmartLinkBadge}
      menuTitle={menuTitle}
      objectName={tr('perform.smart_links.asana.object_name')}
      {...props}
    >
      {children}
    </SmartMenu>
  );
};

const mapStateToProps = state => ({
  hasAsanaIntegration: state.data_sources?.find(({ slug }) => slug === DataSourceSlugs.asana)?.connected,
  asanaSignUpUrl: getAsanaSignUpUrl(state),
});

export default connect(mapStateToProps)(AsanaTaskSmartMenu);
